/**
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const NatObj = require('./NatObj')
const RInfoObjetsVoisins = require('./RInfoObjetsVoisins')
const Nat = require('./Nat')
module.exports = InfoProx
/**
 * Classe utilisée pour donner des informations sur les objets proches du pointeur souris.
 * @constructor
 * @returns {InfoProx}
 */
function InfoProx () {
  this.infoParType = new Array(NatObj.nombreTypesDesignables);
  for (var i=0; i < NatObj.nombreTypesDesignables; i++) this.infoParType[i] = new RInfoObjetsVoisins();
  this.metAZero();
}
/**
 * Réinitialise l'objet.
 * @returns {undefined}
 */
InfoProx.prototype.metAZero = function() {
  this.nombreObjetsProches = 0;
  this.nombrePointsVoisins = 0;
  this.typesProches = new Nat(0,0);
  this.premierPointVoisinRencontre = true;
  this.premierPointVoisin = null;
  this.dernierPointVoisin = null;
  for (var ind = 0; ind < NatObj.nombreTypesDesignables; ind++)
  {
    this.infoParType[ind].nombreVoisins = 0;
    this.infoParType[ind].premierVoisin = null;
    this.infoParType[ind].dernierVoisin = null;
    this.infoParType[ind].premierVoisinRencontre = true;
  }
};
/**
 * Remet à zéro les infos sur les objets qui ne sont pas des points
 * @returns {undefined}
 */
InfoProx.prototype.metAZeroObjetsNonPoints = function() {
  for (var ind = 0; ind < NatObj.nombreTypesDesignables; ind++) {
    if (!NatObj.conversionNumeroNature[ind].isOfNature(NatObj.NTtPoint)) {
      this.infoParType[ind].nombreVoisins = 0;
      this.infoParType[ind].premierVoisin = null;
      this.infoParType[ind].dernierVoisin = null;
      this.infoParType[ind].premierVoisinRencontre = true;
    }
  }
};

/**
 * Renvoie un pointeur sur le premier point proche du pointeur souris.
 * @returns {}
 */
InfoProx.prototype.premierVoisin = function() {
  var elg = null;
  for (var i = 0; (i < NatObj.nombreTypesDesignables) && (elg === null); i++) {
    if (this.infoParType[i].nombreVoisins > 0) elg = this.infoParType[i].premierVoisin;
  }
  return elg;
};
/**
 * Renvoie un pointeur sur le dernier point proche du pointeur souris.
 * @returns {}
 */
InfoProx.prototype.dernierVoisin = function() {
  var elg = null;
  for (var i = NatObj.nombreTypesDesignables - 1; (i >= 0) && (elg === null); i--) {
    if (this.infoParType[i].nombreVoisins > 0) {
      if (this.infoParType[i].dernierVoisin === null) elg = this.infoParType[i].premierVoisin;
      else elg = this.infoParType[i].dernierVoisin;
    }
  }
  return elg;
};
